import { db } from '.';

const getDocRef = docId => db.collection('challengeAttempts').doc(docId);

const getUpdatable = challengeAttempt => {
  return {
    id: challengeAttempt.id,
    ...challengeAttempt,
    challenge: db.collection('challenges').doc(challengeAttempt.challenge.id),
    user: db.collection('users').doc(challengeAttempt.user.id),
    progress: challengeAttempt.progress.map(progressItem => {
      if (Array.isArray(progressItem.history)) return progressItem;
      else {
        return {
          ...progressItem,
          history: db
            .collection('challengeQuestionChats')
            .doc(progressItem.history.id)
        };
      }
    })
  };
};

const getChallengeAttemptFromDB = async id => {
  return {
    id,
    ...(await getDocRef(id).get()).data()
  };
};

const updateChallengeAttemptInDB = async ({ id, ...docData }) =>
  await getDocRef(id).update(docData);

export default {
  get: getChallengeAttemptFromDB,
  update: updateChallengeAttemptInDB,
  getUpdatable: getUpdatable
};
